import { Outlet } from 'react-router';

import { getContractPath } from '../../pages/contracts/lineItemData';
import { RouteNavigation } from '../../shared/components/RouteNavigation';

const NAV_LINKS = [
  { end: true, label: 'Home', to: '/' },
  { label: 'Contract Entry', to: getContractPath() },
  { label: 'Quality Formulas', to: '/quality-formulas' },
  { label: 'Templates', to: '/templates' },
];

export const Layout = ({ availableEmbedHeight }: { availableEmbedHeight?: number }) => (
  <main
    className="slds-template_default"
    style={{
      background: 'var(--slds-g-color-surface-2)',
      display: 'flex',
      flexDirection: 'column',
      minHeight: availableEmbedHeight ?? '100dvh',
    }}
  >
    <RouteNavigation ariaLabel="Primary" links={NAV_LINKS} />
    <Outlet />
  </main>
);
